import { Checkbox, CheckboxProps } from "@mui/material";
import { Dispatch, SetStateAction, useMemo } from "react";

interface Props<T> {
  selectedItems: T[];
  items: T[];
  setItems: Dispatch<SetStateAction<T[]>>;
  compareFn: (a: T, b: T) => boolean;
  checkboxProps?: CheckboxProps;
}

export default function CheckAll<J>({ selectedItems, items, setItems, compareFn, checkboxProps }: Props<J>) {
  const indeterminate = useMemo(() => {
    return (
      !items.every((i) => selectedItems.find((si) => compareFn(si, i))) &&
      items.some((i) => selectedItems.find((si) => compareFn(si, i)))
    );
  }, [items, selectedItems]);
  const selectedItemsInCurrentSet = useMemo(
    () => selectedItems.some((si) => items.find((i) => compareFn(si, i))),
    [items, selectedItems]
  );
  const checked = useMemo(
    () => !!items.find((i) => selectedItems.find((si) => compareFn(si, i))),
    [items, selectedItems]
  );
  const onClick = () => {
    if (selectedItemsInCurrentSet) {
      setItems((prev) => prev.filter((p) => !items.find((i) => compareFn(p, i))));
    } else {
      setItems((prev) => prev.concat(items));
    }
  };

  return (
    <Checkbox
      size="small"
      color="secondary"
      indeterminate={indeterminate}
      checked={checked}
      onClick={onClick}
      {...checkboxProps}
    />
  );
}
